import H from 'constants/httpMethod.const';
import actionEndpointBe from 'utils/mw/actionEndpointBe.util';

export const abeSalon = actionEndpointBe('abeSalon', H.get, 'salon/:salonId/', { pin: false, inert: false });
export const ibeSalon = actionEndpointBe('ibeSalon', H.get, 'salon/:salonId/', { pin: false, inert: true });
